import { createAsyncThunk } from '@reduxjs/toolkit';
import { registerFastStudent } from '../../api/studentsApi';
import { RootState } from '../../redux/reducers';
import { toastr } from 'react-redux-toastr';
import { authSuccess } from '@/redux/actions/authActions';
import LocalStorageService from '@/services/LocalStorageService';
import { appError, appLoading, appSuccess } from '@/redux/actions/appActions';

export const registerTempUser = createAsyncThunk(
  'user/registerTempUser',
  async (_, { getState, rejectWithValue, dispatch}) => {
    const state = getState() as RootState;
    const tempUser = state.user;
    const housingData = state.habitation;
    const schoolName = housingData.schoolName;

    const payload = {
        user: {
            name: tempUser.firstname,
            lastName: tempUser.lastname,
            email: tempUser.email,
            password: tempUser.password,
        },
        civility: tempUser.civility,
        address: housingData.address,
        phoneNumber: tempUser.phone,
        birthday: tempUser.birthdate,
        studentType: 'classic',
        referralCode: null,
        // Si un slug ?school=... a été détecté dans l'URL d'entrée, on l'envoie au
        // back qui rattachera le compte à l'école et appliquera le bon studentType
        // (inclusive/partner). Slug inconnu = back ignore et garde 'classic'.
        ...(schoolName ? { schoolName } : {}),
    };

    try {
      dispatch(appLoading());
      
      const response = await registerFastStudent(payload);
      const { token, refresh_token, data } = response.data;

      const service = LocalStorageService.getService();

      // Store tokens
      service.setToken({ token: token, refresh_token: refresh_token});

      // Store user with correct structure (setUser expects { user: {...} })
      service.setUser({ user: data });

      // Dispatch authSuccess with correct format
      dispatch(authSuccess({
        data: { user: data },
        token: token
      }));

      dispatch(appSuccess());

      toastr.success(
        'Confirmation email envoyée',
        'Un email de confirmation vient de vous être envoyé.'
      );
      return response.data;
    } catch (error: any) {
      dispatch(appError());
      toastr.error(
        'Erreur',
        error?.response?.data?.message || 'Erreur lors de l’inscription'
      );
      return rejectWithValue(error?.response?.data);
    }
  }
);
